import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Field, reduxForm } from "redux-form";
import { TextInput, SelectInput } from "../../../../common/form";
import { MessageBox } from "../../../../common";
import { FormattedMessage, intlShape } from "react-intl";

import genders from "./enums/genders";
import validationUtils from "../../../../../utils/ValidationUtils";
import { MEMBERS_VALIDATION_RULES } from "./membersValidationRules";
import { FINTECH } from "../../../../../utils/Roles";
import * as dataActions from "../../../../../utils/data/dataActions";
import userHasAccess from "../../../../../utils/userHasAccess";
import { ELIGIBILITY } from "../../enums/synchronizationOptions";
import BU from "../../../admin/enums/accountBusinessUnits";

class BasicMemberFields extends React.Component {
  static generateLocalizedRules(values) {
    let rules = {};
    let localRules = {};
    if (values.client.businessAccountType == 1) {
      rules[`memberIdentifier`] = {
        ...MEMBERS_VALIDATION_RULES.memberIdentifier,
        ...{
          regex: {
            value: {
              pattern: /^\d*$/,
              customMessageKey: "validation.customMessages.numeric",
            },
          },
        },
      };
    }
    localRules = { ...MEMBERS_VALIDATION_RULES, ...rules };
    return localRules;
  }
  constructor(props) {
    super(props);
  }
  getChildContext() {
    return {
      scene: this.props.scene,
    };
  }
  render() {
    const clientNumber = this.props.initialValues.client ? this.props.initialValues.client.clientNumber : null;
    const disabled = this.props.disabled || !clientNumber;
    const isClientNonPM = this.props.initialValues.client && this.props.initialValues.client.businessAccountType !== BU.PM;
    const isMemberIdentifierDisabled = !userHasAccess(FINTECH) && ((this.props.syncType === ELIGIBILITY.value && !this.props.add) && isClientNonPM);
    return (
      <div>
        {!clientNumber &&(
          <MessageBox className="alert-warning">
            <FormattedMessage id="members.form.error.noClientNumber" />
          </MessageBox>
        )}
        <form onSubmit={this.props.handleSubmit}>
          <fieldset disabled={disabled}>
            <Field
              id="firstName"
              name="firstName"
              component={TextInput}
              required={true}
              type="text"
              label={<FormattedMessage id="members.form.firstName" />}
              />
            <Field
              id="lastName"
              name="lastName"
              component={TextInput}
              required={true}
              type="text"
              label={<FormattedMessage id="members.form.lastName" />}
              />
            <Field
              id="memberGenderType"
              name="memberGenderType"
              component={SelectInput}
              disabled={disabled}
              required={true}
              options={genders}
              label={<FormattedMessage id="members.form.memberGenderType" />}
              />
            {!this.props.initialValues.client.isAutomaticMemberIdentifier && (
              <Field
              id="memberIdentifier"
              name="memberIdentifier"
              component={TextInput}
              required={true}
              disabled={isMemberIdentifierDisabled}
              type="text"
              label={<FormattedMessage id="members.form.memberIdentifier"/>}
                />
                )}
          </fieldset>
        </form>
      </div>
    );
  }
}

BasicMemberFields.propTypes = {
  dataActions: PropTypes.object,
  disabled: PropTypes.bool,
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  roleId: PropTypes.number,
  scene: PropTypes.string,
  validation: PropTypes.object,
  syncType: PropTypes.string,
  add: PropTypes.bool,
};

BasicMemberFields.defaultProps = {
  disabled: false,
  scene: "",
};

BasicMemberFields.contextTypes = {
  getData: PropTypes.func,
  intl: intlShape,
};

BasicMemberFields.childContextTypes = {
  scene: PropTypes.string,
};

function mapStateToProps(state) {
  return {
    roleId: state.auth.user.roleId,
    syncType: state.data.clients && state.data.clients.active && state.data.clients.active.syncType
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dataActions: bindActionCreators(dataActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
  withRef: true,
})(
  reduxForm({
    form: "member",
    validate: (values, props) =>
      validationUtils.validate(
        values,
        BasicMemberFields.generateLocalizedRules(values),
        props.roleId
      ),
  })(BasicMemberFields)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/BasicMemberFields.js